import React, { useState } from 'react'
import RecursiveContainer from '../RecursiveContainer';

function CreateCaseAnonymous({ field, formValues, onChangeUpdate, errors, onBlurValidate }) {
  const [isAnonymous, setIsAnonymous] = useState(formValues["annonymous"] || false);
  const nameFields = [{
            label: "First Name",
            type: "input",
            name: "firstName",
            hideWhenAnonymous: true,
            required: true,
            error: "Your first name is a required field",
            placeholder: "e.g. Maria"
          },
          {
            label: "Last Name",
            type: "input",
            hideWhenAnonymous: true,
            name: "lastName",
            required: true,
            error: "Your last name is a required field",
            placeholder: "e.g. Gomez"
          }]

  return (
        <div className="w-full font-plexsans">
        <label
            className={`flex items-start gap-2.5 p-3.5 rounded-lg border-[1.5px] cursor-pointer transition-colors ${
            isAnonymous
                ? "border-tan bg-[rgba(138,98,49,.08)]"
                : "border-[rgba(20,33,61,.15)]"
            }`}
        >
            <input
                type="checkbox"
                checked={isAnonymous}
                onChange={(e) => {
                    setIsAnonymous(e.target.checked);
                    onChangeUpdate(e, field);

                }}
                className="mt-0.5 h-4 w-4 accent-tan flex-none"
            />

            <div>
                <div className="font-medium text-navy text-[14px] mb-0.5">
                Continue anonymously
                </div>

                <p className="text-xs text-[rgba(20,33,61,.55)] mt-0.5 max-w-xl">
                Your identity will not be visible to attorneys until you choose to
                share it. First name and last name will not be collected.
                </p>
            </div>
            </label>

        {
            !isAnonymous && (
                <div className='w-full mt-4 grid grid-cols-1 lg:grid-cols-2 gap-4'>
                    {nameFields.map((field) => (
                        <RecursiveContainer
                            key={field.name}
                            field = {field}
                            formValues={formValues}
                            onChangeUpdate={onChangeUpdate}
                            errors={errors}
                            onBlurValidate={onBlurValidate}
                        />
                    ))}
                </div>
            )
        }
        </div>
        )
}

export default CreateCaseAnonymous
